import dayjs from 'dayjs'
import { formatMoney } from '../functions'

export const AGENDA_TEMPLATE_KEY = '@petland/agenda-inteligente-template'

export const DEFAULT_AGENDA_TEMPLATE =
  'Olá, {cliente}! 😊\n\nPassando para confirmar o agendamento {pet} no dia {data}, às {hora}, na {loja}. O valor previsto é de {valor}. Podemos confirmar? 🐾'

export const AGENDA_TEMPLATE_VARIABLES = [
  { var: '{pet}', desc: '"do Rex" / "da Luna" / "da duplinha Rex e Mel" / "da turminha Rex, Mel e Thor" — artigo automático pelo gênero' },
  { var: '{cliente}', desc: 'Nome do tutor' },
  { var: '{loja}', desc: 'Nome da loja' },
  { var: '{data}', desc: 'Data do agendamento (DD/MM/AAAA)' },
  { var: '{hora}', desc: 'Horário do agendamento (HH:mm)' },
  { var: '{valor}', desc: 'Valor total previsto (R$ 0,00)' },
]

export function loadAgendaTemplate(storeId) {
  if (!storeId) return DEFAULT_AGENDA_TEMPLATE

  try {
    return localStorage.getItem(`${AGENDA_TEMPLATE_KEY}:${storeId}`) || DEFAULT_AGENDA_TEMPLATE
  } catch {
    return DEFAULT_AGENDA_TEMPLATE
  }
}

export function saveAgendaTemplate(template, storeId) {
  if (!storeId) return false

  try {
    localStorage.setItem(`${AGENDA_TEMPLATE_KEY}:${storeId}`, template)
  } catch {
    return false
  }

  return true
}

export function cleanPhone(phone) {
  return phone ? phone.replace(/\D/g, '') : ''
}

export function buildWhatsAppHref(phone, message) {
  const cleanedPhone = cleanPhone(phone)
  const phoneWithCountryCode = cleanedPhone.startsWith('55')
    ? cleanedPhone
    : `55${cleanedPhone}`

  return `https://wa.me/${phoneWithCountryCode}?text=${encodeURIComponent(message)}`
}

function formatDate(date) {
  if (!date) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return dayjs(date).format('DD/MM/YYYY')
  return date
}

function formatValue(value) {
  return `R$ ${formatMoney(Number(value))}`
}

function petArticle(name, sex) {
  if (sex === 'M') return `do ${name}`
  if (sex === 'F') return `da ${name}`
  return `do(a) ${name}`
}

function buildPetsPhrase(pets = []) {
  if (pets.length === 0) return ''
  if (pets.length === 1) return petArticle(pets[0].nome, pets[0].sexo)
  if (pets.length === 2) return `da duplinha ${pets[0].nome} e ${pets[1].nome}`

  const names = pets.slice(0, -1).map(pet => pet.nome).join(', ')
  return `da turminha ${names} e ${pets[pets.length - 1].nome}`
}

export function renderAgendaMessage(template, pets, time, customer, storeName, date, value) {
  const petsPhrase = buildPetsPhrase(pets)

  return template
    .replace(/\{pet\}/g, petsPhrase)
    .replace(/\{pets\}/g, petsPhrase)
    .replace(/\{hora\}/g, time || '')
    .replace(/\{data\}/g, formatDate(date))
    .replace(/\{cliente\}/g, customer || '')
    .replace(/\{loja\}/g, () => storeName || '')
    .replace(/\{valor\}/g, formatValue(value))
}
